import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	expand: {
		id: 'page-container-v2.common.sidebar.resize-button-tooltip.expand',
		defaultMessage: 'Expand',
		description: 'The expand sidebar tooltip text',
	},
	collapse: {
		id: 'page-container-v2.common.sidebar.resize-button-tooltip.collapse',
		defaultMessage: 'Collapse',
		description: 'The collapse sidebar tooltip text',
	},
});
